import React, { useContext } from 'react'
import { Redirect, Route, Router, Switch, useRouteMatch } from 'react-router-dom'
import Admin from './Admin'
import AdminLogIn from './AdminLogIn'
import { firebaseAuth } from './AuthProvider';
import EditPage from './EditPage'
import EditTemplate from './EditTemplate';
import AdminHeader from './AdminHeader';
import AdminPrijaveGosti from './AdminPrijaveGosti'
import AdminPrijavePredavaca from './AdminPrijavePredavaca';
import EditIzlagaci from './EditIzlagaci';
import EditTimer from './EditTimer';





function AdminRouter(props) {

    return (<React.Fragment>
    <AdminHeader/>
      <Switch>


      {/* TODO FIX TOKEN !!!!! */}
      
      <Route exact path="/admin" component={Admin}/> 
      <Route exact path='/admin/login' component={AdminLogIn} /> 
        {/* TODO MOŽDA PROMJENITI NAZIVRUTE */}
        <Route exact path='/admin/pregled' component={AdminPrijaveGosti} />
        <Route exact path='/admin/predavaci' component={AdminPrijavePredavaca} />
      <Route exact path='/admin/edit' component={EditPage} /> 
      <Route exact path='/admin/edit/izlagaci' component={EditIzlagaci} /> 
      <Route exact path='/admin/edit/timer' component={EditTimer} /> 


      <Route exact path={`/admin/edit/:editID`} component={EditTemplate}/>
      
      </Switch>


      </React.Fragment>
    )
}

export default AdminRouter
